var Standings = function() {
    var update_filters = function(data, update_leagues) {
        var opt = '';
        if (update_leagues) {
            for (var ix in data['leagues']) {
                opt += '<option value="' + data['leagues'][ix][0] + '">' + data['leagues'][ix][1] + '</option>';
            }
            $('#league_selector').html(opt);
        }

        opt = '';
        for (var iy in data['seasons']) {
            opt += '<option value="' + data['seasons'][iy][0] + '">' + data['seasons'][iy][1] + '</option>';
        }
        $('#season_selector').html(opt);
    };

    return {
        init: function() {
            $('#applyfilters').on('click', function(e) {
                window.location.replace(
                    (Generic.mobile ? '/m' : '') +
                    '/vathmologia/t/' + $('#league_selector').val() + '/' +
                        encodeURIComponent(
                            $('#league_selector option:selected').html().replace('/', '-')).replace(/%20/g,'+') +
                        '/' + $('#season_selector').val());
            });

            $('#country_selector').on('change', function() {
                Ajax.getStandingsFiltersData(this.value, false, function(data) {
                    update_filters(data, true);
                });
            });

            $('#league_selector').on('change', function() {
                Ajax.getStandingsFiltersData($('#country_selector').val(), this.value, function(data) {
                    update_filters(data, false);
                });
            });
        }
    };
}();
